import EventBus from '../event-bus';
import { debounce } from './app-service';
import { callerPostMsg } from './postmsg-service';
import {
    UPDATE_STATUS,
    GET_FINAL_STATUS,
    APPEND_EXTERNAL_HTML,
    REMOVE_EXTERNAL_HTML
} from '../constants/event-constants';

const APP_ID = 'app';

function publishStatus() {
    EventBus.$on(UPDATE_STATUS, status => {
        callerPostMsg('getCpfStatus', status);
    });
}

function publishFinalStatus() {
    EventBus.$on(GET_FINAL_STATUS, status => {
        callerPostMsg('finalPayment', status);
    });
}

function publishAppendHtml() {
    EventBus.$on(APPEND_EXTERNAL_HTML, config => {
        callerPostMsg('setCpfExternalHtml', config);
    });
}

function publishRemoveHtml() {
    EventBus.$on(REMOVE_EXTERNAL_HTML, id => {
        callerPostMsg('removeCpfExternalHtml', id);
    });
}

function publishState() {
    const callback = debounce(() => {
        const appNode = document.getElementById(APP_ID);
        const state = {
            height: appNode?.clientHeight,
            width: appNode?.clientWidth
        };
        callerPostMsg('getCpfState', state);
    });
    const observer = new ResizeObserver(callback);
    
    window.addEventListener('load', () => {
        const appNode = document.getElementById(APP_ID);
        observer.observe(appNode);
        callback();
    });
}

publishState();
publishStatus();
publishAppendHtml();
publishRemoveHtml();
publishFinalStatus();
